<template>
  <b-table
    :items="tableData"
    :fields="fields"
    responsive="lg"
    :show-empty="true"
    @sort-changed="sortChanged"
    outlined
    style="min-height:500px"
  >
    <template
      v-for="(col, idx) in fields"
      v-slot:[formattedCellName(col.key)]="row"
    >
      <div 
        v-bind:key="idx"
        class="td-cell row justify-content-between pr-2"
        :style="!col.editable ? 'pointer-events: none !important;' : ''"
        @click="onEditCell(col, row)"
        v-if="!row.item[`onEdit${col.key}`]"
      >
        <div class="chip-list" style="box-sizing: border-box;" v-if="col.fieldStyle && col.fieldStyle.isChip && formattedField(col, row) && col.isArray">
          <button
            :class="col.fieldStyle.class"
            :style="col.fieldStyle.style"
            v-for="(data, idxx) in [formattedField(col, row, true)[0]]"
            :key="idxx"
          >
            {{ data[col.subKey] || '-' }}
          </button>

          <span> and {{ formattedField(col, row, true).length - 1 }} more</span>
        </div>
        
        <button
          v-else-if="col.fieldStyle && col.fieldStyle.isChip && formattedField(col, row)"
          :class="col.fieldStyle.class"
          :style="col.fieldStyle.style"
        >
          {{ formattedField(col, row) || '-' }}
        </button>

        <span v-else>{{ formattedField(col, row) || '-'}}</span>

        <img 
          v-if="col.editable"
          src="https://cdn-icons-png.flaticon.com/128/10146/10146590.png" 
          style="width:15px; height:15px; cursor: pointer;" 
          class="edit-icon my-auto mr-auto ml-2"
        />
      </div>

      <div
        class="editable-cell row justify-content-between"
        v-bind:key="'edit' + idx"
        v-else
      >
        <div class="col-9">
          <Select
            v-if="col.inputType == 'select' && col.params"
            autoload
            class="mb-0 mt-1"
            :track-by="col.params['trackBy'] || ''"
            :valueField="col.params['valueField'] || ''"
            :textField="col.params['textField'] || ''"
            :moduleName="col.params['moduleName']"
            :endpoint="col.params['endpoint'] || ''"
            :placeholder="col.placeholder"
            v-model="tableData[getIndexValue(row)][col.key]"
            noErrorMessage=true
          />

          <Multiselect
            v-else-if="col.inputType == 'multiselect' && col.params"
            autoload
            :searchable="true"
            :multiple="false"
            :clear-on-select="false"
            :close-on-select="false"
            :show-labels="false"
            label="name"
            :track-by="col.params['trackBy'] || ''"
            :valueField="col.params['valueField'] || ''"
            :textField="col.params['textField'] || ''"
            :moduleName="col.params['moduleName']"
            :endpoint="col.params['endpoint'] || ''"
            :placeholder="col.placeholder"
            v-model="tableData[getIndexValue(row)][col.key]"
            noErrorMessage=true
          />

          <CustomSelect
            v-else-if="col.inputType == 'customselect' && col.params"
            autoload
            :customData="getCustomDowndown(col.params['moduleName'])"
            :valueField="col.params['valueField'] || ''"
            :textField="col.params['textField'] || ''"
            :moduleName="col.params['moduleName']"
            :endpoint="col.params['endpoint'] || ''"
            :placeholder="col.placeholder"
            v-model="tableData[getIndexValue(row)][col.key]"
            noErrorMessage=true
          />

          <vue-tags-input
            v-else-if="col.inputType == 'tags'"
            class="form-group"
            v-model="tableData[getIndexValue(row)].tag"
            :tags="tableData[getIndexValue(row)][col.key]"
            @tags-changed="newTags => tableData[getIndexValue(row)][col.key] = newTags"
            :placeholder="$t('job.form.skills.placeholder')"
          />

          <TextField 
            v-else-if="col.isNumber && col.subKey"
            class="mb-0 mt-1"
            :placeholder="col.placeholder"
            v-model="tableData[getIndexValue(row)][col.key][col.subKey]"
            type="number"
            noErrorMessage=true
          />

          <TextField 
            v-else
            class="mb-0 mt-1"
            :placeholder="col.placeholder"
            v-model="tableData[getIndexValue(row)][col.key]"
            type="text"
            noErrorMessage=true
          />
        </div>

        <div class="col-3 save-icon my-auto ml-auto pt-1">
          <feather @click="onSave(row)" type="save"></feather>
          <feather class="ml-1" @click="onEditCell(col, row, false, true)" type="x"></feather>
        </div>
      </div>

    </template>
  </b-table>
</template>

<script>
import TextField from '@components/form2/textfield.vue'
import Select from '@components/form2/select'
import Multiselect from '@components/form2/select/multiselect'
import Dropdown from '@src/static/dropdown'
import CustomSelect from '@components/form2/select/customSelect.vue'
import VueTagsInput from '@johmun/vue-tags-input';
export default {
  components: {
    TextField, Select, Multiselect, CustomSelect, VueTagsInput
  },
  props: {
    fields: Array,
    items: Array,
    moduleName: String,
    endpoint: {
      type: String,
      default: 'updateField',
    }
  },
  data() {
    return {
      Dropdown,
      tableData: [],
      oldData: [],
      isFetched: false,
      defaultFields: [],
      sortBy:'title',
      sortDesc: false
    }
  },
  methods: {
    sortChanged(e){
      this.$emit('sortChange', { ...e })
    },
    formattedCellName(field){
      return `cell(${field})`;
    },
    formattedField(col, row, list = false) {
      let { key, subKey, isArray, isNumber } = col
      let { item } = row

      if(subKey && !list) {

        if(isNumber)
          return item[key] && item[key][subKey] ? item[key][subKey] : ''

        if(isArray)
          return item[key].length ? item[key][0][subKey] : ''

        return item[key][subKey]
      }

      return item[key]
    },
    onEditCell(col, row, is_editable = true, is_cancelled = false) {
      if(col.editable) {
        this.tableData = this.tableData.map( item => {
          if(item._id == row.item._id) {
            item[`onEdit${col.key}`] = is_editable
  
            if(is_cancelled) {
              for(var key in this.oldData) {
                let data = this.oldData[key]
                if(data._id == row.item._id) {
                  item[col.key] = data[col.key]
                }
              }
            }
          }
  
          return item
        })
      }
    },
    onSave(row) {
      let { item, field } = row
      let { key, label, params, isArray, isNumber } = field
      
      let value = item[key]

      if(params && params.trackBy) {
        value = item[key][params.trackBy]
        
        if(isNumber) {
          console.log('isNumber', isNumber)
        }

        if(isArray) {  
          value = value != undefined ? [value] : []
          this.tableData[this.getIndexValue(row)][key] = [item[key]]
        }

      }

      let data = {
        id: item._id,
        key,  
        value
      }

      if(!data.value || (isArray && data.value.length == 0)) {
        this.$bvToast.toast(`Please fill the ${label} field to save changes.`, {
          title: 'Notification',
          variant:'danger'
        })
        return false
      }

      this.$bvModal.msgBoxConfirm(`Please confirm that you want to save changes?`, {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res) {
          this.$store.dispatch(`${this.moduleName}/${this.endpoint}`, data)
          .then(result => {
            if(result) {
              this.onEditCell(field, row, false)
            }
          })
        }
      })
    },
    onFetchData(data) {
      let hasNumberFields = this.fields.filter(ele => ele.isNumber)
      for(let i in data) {
        let obj = { ...data[i] }
        if (typeof obj === "object"){
          for(let j in hasNumberFields) {
            let {key, subKey} = hasNumberFields[j]
            if(obj[key] == undefined) { //check if number field is no undefined
              obj[key] = {
                [subKey]: 0
              }
            }
          }
          this.tableData.push(obj)
          this.oldData.push(obj)
        }
      }
      this.isFetched = true
    },
    getCustomDowndown(moduleName){
      let list = []
      let data = this.Dropdown[moduleName]
      for(let key in data){
        let obj = {}
        obj.value = data[key]
        obj.text = data[key]
        list.push(obj)
      }

      return [...list]
    },
    formattedValidation(col, row) {
      return this.tableData[this.getIndexValue(row)][col.key] == undefined
    },
    getIndexValue(row) {
      let { item } = row
      for(let key in this.tableData) {
        if(item._id == this.tableData[key]._id)
          return key

        // return row.index
      }
    }
  },
  mounted() {
    if(!this.isFetched)
      this.onFetchData(this.items)
  }
}
</script>
<style lang="scss">

.custom-chip {
  display: inline-block;
  padding: 0 15px;
  height: 30px;
  line-height: 30px;
  border-radius: 25px;
  background-color: #E8E8E8;
  margin: 4px 0;
  border: #E8E8E8;
  font-weight: 600;
}

.chip-status8 {
  background-color: #FFA5A5;
  color: #800000;
  .icon-dot {
    background: #800000;
  }
}

th div {
  white-space: nowrap;
}
img.edit-icon {
  display: none;
}

td {
  vertical-align: middle !important;
}

.editable-cell {
  min-width: 350px !important;
  white-space: nowrap;
}

.td-cell {
  cursor: pointer;
  margin-left: auto;
  display: inline-block !important;
  white-space: nowrap;
    span {
      top: 50%;
    }
}

.td-cell:hover > img.edit-icon,
.save-icon {
  display: inline-block !important;
}

.save-icon {
  i {
    cursor: pointer;
  }
}

.vue-tags-input {
  max-width: 100%!important;
  position: relative !important;
  background-color: #fff !important;
}
.ti-input {
  display: block;
  width: 100%;
  min-height: calc( 1.5em + 1rem + 2px ) !important;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #4b4b5a;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e2e7f1;
  border-top-color: rgb(226, 231, 241);
  border-top-style: solid;
  border-top-width: 1px;
  border-right-color: rgb(226, 231, 241);
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-color: rgb(226, 231, 241);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-left-color: rgb(226, 231, 241);
  border-left-style: solid;
  border-left-width: 1px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  border-radius: 0.3rem;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition-property: border-color, box-shadow;
  transition-duration: 0.15s, 0.15s;
  transition-timing-function: ease-in-out, ease-in-out;
  transition-delay: 0s, 0s;
}
.ti-tag.ti-valid {
  position: relative;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  z-index: 2;
  margin-bottom: 0 !important;
  background-color: #5369f8 !important;
}
.ti-actions {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: normal;
  width: 22px;
  text-align: center;
  line-height: 22px;
  transition: all .2s ease;
  border-radius: 5px;
}

</style>